module.exports = window['@emotion/react'];